import { servicingApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SERVICING_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/servicing`,
  {
    GET_PAYMENTS: 'GET_PAYMENTS',
    GET_PAYMENT_SCHEDULE: 'GET_PAYMENT_SCHEDULE',
    GET_SUMMARY: 'GET_SUMMARY',
    GET_ESCROW_DISBURSEMENTS: 'GET_ESCROW_DISBURSEMENTS',
    GET_INTERACTIONS: 'GET_INTERACTIONS',
    GET_DRAW_REQUESTS: 'GET_DRAW_REQUESTS',
  },
);

export const getServicingPaymentsAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await servicingApi.getPayments({ applicationId });

      return dispatch({
        type: SERVICING_ACTION_TYPE.GET_PAYMENTS,
        payload: data,
      });
    },
);

export const getServicingPaymentScheduleAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await servicingApi.getPaymentSchedule({ applicationId });

      return dispatch({
        type: SERVICING_ACTION_TYPE.GET_PAYMENT_SCHEDULE,
        payload: data,
      });
    },
);

export const getServicingSummaryAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await servicingApi.getSummary({ applicationId });

      return dispatch({
        type: SERVICING_ACTION_TYPE.GET_SUMMARY,
        payload: data,
      });
    },
);

export const getServicingEscrowDisbursementsAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await servicingApi.getEscrowDisbursements({ applicationId });

      return dispatch({
        type: SERVICING_ACTION_TYPE.GET_ESCROW_DISBURSEMENTS,
        payload: data,
      });
    },
);

export const createServicingEscrowDisbursementAction = catchAsyncActionError(
  ({ applicationId, ...body }) =>
    async dispatch => {
      await servicingApi.createEscrowDisbursement({ applicationId, ...body });

      return dispatch(getServicingEscrowDisbursementsAction({ applicationId }));
    },
);

export const updateServicingEscrowDisbursementAction = catchAsyncActionError(
  ({ applicationId, disbursementId, ...body }) =>
    async dispatch => {
      await servicingApi.updateEscrowDisbursement({ applicationId, disbursementId, ...body });

      return dispatch(getServicingEscrowDisbursementsAction({ applicationId }));
    },
);

export const deleteServicingEscrowDisbursementAction = catchAsyncActionError(
  ({ applicationId, disbursementId }) =>
    async dispatch => {
      await servicingApi.deleteEscrowDisbursement({ applicationId, disbursementId });

      return dispatch(getServicingEscrowDisbursementsAction({ applicationId }));
    },
);

export const getServicingInteractionsAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await servicingApi.getInteractions({ applicationId });

      return dispatch({
        type: SERVICING_ACTION_TYPE.GET_INTERACTIONS,
        payload: data,
      });
    },
);

export const createServicingInteractionAction = catchAsyncActionError(
  ({ applicationId, ...body }) =>
    async dispatch => {
      await servicingApi.createInteraction({ applicationId, ...body });

      return dispatch(getServicingInteractionsAction({ applicationId }));
    },
);

export const updateServicingInteractionAction = catchAsyncActionError(
  ({ applicationId, interactionId, ...body }) =>
    async dispatch => {
      await servicingApi.updateInteraction({ applicationId, interactionId, ...body });

      return dispatch(getServicingInteractionsAction({ applicationId }));
    },
);

export const deleteServicingInteractionAction = catchAsyncActionError(
  ({ applicationId, interactionId }) =>
    async dispatch => {
      await servicingApi.deleteInteraction({ applicationId, interactionId });

      return dispatch(getServicingInteractionsAction({ applicationId }));
    },
);

export const createServicingPaymentAction = catchAsyncActionError(
  ({ applicationId, ...body }) =>
    async dispatch => {
      await servicingApi.createPayment({ applicationId, ...body });

      return dispatch(getServicingPaymentsAction({ applicationId }));
    },
);

export const updateServicingPaymentAction = catchAsyncActionError(
  ({ applicationId, paymentId, ...body }) =>
    async dispatch => {
      await servicingApi.updatePayment({ applicationId, paymentId, ...body });

      return dispatch(getServicingPaymentsAction({ applicationId }));
    },
);

export const deleteServicingPaymentAction = catchAsyncActionError(
  ({ applicationId, paymentId }) =>
    async dispatch => {
      await servicingApi.deletePayment({ applicationId, paymentId });

      return dispatch(getServicingPaymentsAction({ applicationId }));
    },
);

export const reverseServicingPaymentAction = catchAsyncActionError(
  ({ applicationId, paymentId, ...body }) =>
    async dispatch => {
      await servicingApi.reversePayment({ applicationId, paymentId, ...body });

      return dispatch(getServicingPaymentsAction({ applicationId }));
    },
);

export const getServicingDrawRequestsAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await servicingApi.getDrawRequests({ applicationId });

      return dispatch({
        type: SERVICING_ACTION_TYPE.GET_DRAW_REQUESTS,
        payload: data,
      });
    },
);

export const createServicingDrawRequestAction = catchAsyncActionError(
  ({ applicationId, ...body }) =>
    async dispatch => {
      await servicingApi.createDrawRequest({ applicationId, ...body });

      return dispatch(getServicingDrawRequestsAction({ applicationId }));
    },
);

export const updateServicingDrawRequestAction = catchAsyncActionError(
  ({ applicationId, drawRequestId, ...body }) =>
    async dispatch => {
      await servicingApi.updateDrawRequest({ applicationId, drawRequestId, ...body });

      return dispatch(getServicingDrawRequestsAction({ applicationId }));
    },
);
